import { FlexSpinner } from 'components'
import { useCurrentProving } from 'hooks/useCurrentProving'
import * as React from 'react'
import { useAcceptedProvingChangesQuery } from './hooks/index'
import { Page, Section } from './Layout'
import { EditingHistoryList } from './lists'

export const PageEditingHistory: React.FC = () => {
  const [proving] = useCurrentProving()
  const { data, loading, error } = useAcceptedProvingChangesQuery({
    variables: {
      id: proving._id,
    },
  })
  const changes =
    data && data.acceptedProvingChanges ? data.acceptedProvingChanges : []

  return (
    <Page>
      <FlexSpinner loading={loading} error={error}>
        <Section label="Bearbeitungshistorie">
          <EditingHistoryList items={changes as any} />
        </Section>
      </FlexSpinner>
    </Page>
  )
}
